module.exports = __webpack_public_path__ + "static/media/hand-heart.b295d3bc.svg";